<!-- 批量设置 -->
<template>
  <div>
    <setDialog
      dialogTitle="批量设置"
      :centerDialogVisible="setVisible"
      @resetPopupData="setUpdateVisible"
      @submitPopupData="setSubmitPopupData"
      :popupWidth="'420px'"
    >
      <el-form :model="setForm" :rules="rules" ref="setForm">
        <el-form-item
          label="库存："
          :label-width="formLabelWidth"
          prop="skuStock"
        >
          <el-input
            v-model="setForm.skuStock"
            autocomplete="off"
            placeholder="请输入库存"
            @input="setForm.skuStock = setForm.skuStock.replace(/[^0-9.]/g, '')"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="起订量："
          :label-width="formLabelWidth"
          prop="minOrderQuantity"
        >
          <el-input
            v-model="setForm.minOrderQuantity"
            autocomplete="off"
            placeholder="请输入起订量"
            @input="
              setForm.minOrderQuantity = setForm.minOrderQuantity.replace(
                /[^0-9.]/g,
                ''
              )
            "
          ></el-input>
        </el-form-item>
        <el-form-item
          label="交货期："
          :label-width="formLabelWidth"
          prop="deliveryType"
        >
          <el-select
            style="width: 250px"
            v-model="setForm.deliveryType"
            placeholder="请选择交货期"
          >
            <el-option
              v-for="item in [
                { label: '现货', value: 1 },
                { label: '期货', value: 2 },
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="发货周期(天)："
          :label-width="formLabelWidth"
          prop="deliverTime"
        >
          <el-input
            v-model="setForm.deliverTime"
            autocomplete="off"
            placeholder="请输入发货周期"
            @input="
              setForm.deliverTime = setForm.deliverTime.replace(/[^0-9.]/g, '')
            "
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="计量单位：" :label-width="formLabelWidth" prop="unitId">
            <el-select
              v-model="setForm.unitId"
              placeholder="请选择计量单位"
              @change="unitHandle"
              style="width:250px"
            >
              <el-option
                v-for="item in unitListTable"
                :key="item.unitId"
                :label="item.unitName"
                :value="item.unitId"
              ></el-option>
            </el-select>
          </el-form-item> -->
        <el-form-item
          label="计量单位："
          :label-width="formLabelWidth"
          prop="unitValue"
        >
          <el-select
            v-model="setForm.unitValue"
            placeholder="请选择计量单位"
            @change="unitHandle"
            style="width: 250px"
          >
            <el-option
              v-for="item in unitListTable"
              :key="item.unitId"
              :label="item.unitName"
              :value="item.unitName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="订单是否确认："
          :label-width="formLabelWidth"
          prop="isConfirm"
        >
          <el-select
            style="width: 250px"
            v-model="setForm.isConfirm"
            placeholder="请选择订单是否确认"
          >
            <el-option
              v-for="item in [
                { label: '是', value: 1 },
                { label: '否', value: 0 },
              ]"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </setDialog>
  </div>
</template>

<script>
import setDialog from '@/components/common/epecDialog';
import api from '../../../api/product/index.js';
import util from '../../../utils/utils';
export default {
  props: {
    unitListTable: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    let validateSkuStock = (rule, value, callback) => {
      let pattern =
        /^((0\.\d{1,3})|([1-9][0-9]{0,5}\.\d{1,3})|([1-9][0-9]{0,5})|1000000)$/;
      console.log(pattern.test(value));
      console.log(value);
      // if (value === ''||value===null) {
      //   callback(new Error('请输入0-100万之间的正数，最多三位小数'));
      // } else
      if (!pattern.test(value)) {
        callback(new Error('请输入0-100万之间的正数，最多三位小数'));
      } else {
        callback();
      }
    };
    let validateMinOrderQuantity = (rule, value, callback) => {
      let pattern =
        /^((0\.\d{1,3})|([1-9][0-9]{0,5}\.\d{1,3})|([1-9][0-9]{0,5})|1000000)$/;
      console.log(pattern.test(value));
      console.log(value);
      // if (value === ''||value===null) {
      //   callback(new Error('请输入0-100万之间的正数，最多三位小数'));
      // } else
      if (!pattern.test(value)) {
        callback(new Error('请输入0-100万之间的正数，最多三位小数'));
      } else {
        callback();
      }
    };
    let validateDeliverTime = (rule, value, callback) => {
      let pattern = /^(?:0|[1-9][0-9]?|100)$/;
      console.log(pattern.test(value));
      console.log(value);
      // if (value === ''||value===null) {
      //   callback(new Error('请输入0-100万之间的正数，最多三位小数'));
      // } else
      if (!pattern.test(value)) {
        callback(new Error('请输入0-100之间的正整数'));
      } else {
        callback();
      }
    };
    return {
      setVisible: true,
      rules: {
        skuStock: [
          { required: true, message: '请输入库存', trigger: 'blur' },
          { validator: validateSkuStock, trigger: 'blur' },
          // { required: true, message: '请输入库存', trigger: 'blur' },
          // { type: 'number',  message: '请输入数字', trigger: 'blur' }
        ],
        minOrderQuantity: [
          { required: true, message: '请输入起订量', trigger: 'blur' },
          { validator: validateMinOrderQuantity, trigger: 'blur' },
          // { type: 'number', message: '请输入数字', trigger: 'blur' }
        ],
        deliverTime: [
          { required: true, message: '请输入发货周期', trigger: 'blur' },
          { validator: validateDeliverTime, trigger: 'blur' },
          // { required: true, message: '请输入发货周期', trigger: 'blur' },
          // { type: 'number', message: '请输入数字', trigger: 'blur' }
        ],
        unitValue: [
          { required: true, message: '请选择计量单位', trigger: 'change' },
        ],
        isConfirm: [
          { required: true, message: '请选择订单是否确认', trigger: 'change' },
        ],
        deliveryType: [
          { required: true, message: '请选择交货期', trigger: 'change' },
        ],
      },
      setForm: {
        skuStock: null,
        minOrderQuantity: null,
        deliverTime: 2,
        isConfirm: 1, //产品要求默认为1
        unitId: null,
        unitValue: null,
        deliveryType: 1,
      },
      unitList: [],
      formLabelWidth: '130px',
    };
  },

  components: { setDialog },

  computed: {},

  created() {
    this.getUnitInCategroy();
  },
  methods: {
    //获取分类下的单位列表
    async getUnitInCategroy() {
      let param = {
        categoryId: this.$store.state.productList.categoryId,
      };
      let res = await api.getUnitByCategory(param);
      console.log(res);
      if (res.code == 200) {
        this.unitList = res.data;
      }
    },
    // 批量弹框的单位选择
    unitHandle(val) {
      let obj = util.getSelectLabel(this.unitListTable, val, 'unitName');
      console.log(obj);
      this.setForm.unitId = obj.unitId;
      // this.ruleForm.taxName = obj.taxRateValue;
    },
    setUpdateVisible() {
      this.$emit('setUpdateVisible', 2);
    },
    setSubmitPopupData() {
      this.$refs['setForm'].validate((valid) => {
        if (valid) {
          this.$emit('setSubmitPopupData', this.setForm);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped></style>
